export default __webpack_public_path__ + "static/media/IMAGE_16.20937e5e.png";